module.exports = "https://redage.akamaized.net/src/views/donate/sapper/images/logo-sapper.png";